import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import styles from './DeliveryDetailsPrintModal.module.scss';

const DeliveryDetailsPrintModal = ({
  show,
  onHide,
  selectedOrders = [],
  onPrintWithZebra,
}) => {
  // State to manage showing the notes input
  const [includeDeliveryNote, setIncludeDeliveryNote] = useState(false);

  const handlePrint = () => {
    // Pass the delivery note only if checkbox is checked
    onPrintWithZebra(includeDeliveryNote);
  };

  const handleCheckboxChange = (e) => {
    setIncludeDeliveryNote(e.target.checked);
  };

  const handleOnHide = () => {
    setIncludeDeliveryNote(false);

    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleOnHide}
      centered
      size='lg'
      className={styles.modal}
    >
      <Modal.Header closeButton>
        <Modal.Title>Delivery Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.ordersList}>
          {selectedOrders.map((order) => (
            <div key={order.purchaseId} className={styles.orderItem}>
              <h5>Purchase ID: {order.purchaseId}</h5>
              <div className={styles.details}>
                <p>
                  <strong>Receiver:</strong> {order.receiverName}
                </p>
                <p>
                  <strong>Address:</strong> {order.houseAddress}
                </p>
                <p>
                  <strong>City:</strong> {order.city}
                </p>
                <p>
                  <strong>Mobile:</strong>{' '}
                  {order.deliveryMobile || order.creatorMobile}
                </p>

                <div className={styles.deliveryNoteSection}>
                  {order.deliveryNote && (
                    <p>
                      <strong>Delivery Note:</strong> {order.deliveryNote}
                    </p>
                  )}
                  {order.deliveryNote && (
                    <Form.Group>
                      <Form.Check
                        type='checkbox'
                        label='Add Note to the sticker'
                        checked={includeDeliveryNote}
                        onChange={handleCheckboxChange}
                      />
                    </Form.Group>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
        <Button variant='primary' onClick={handlePrint}>
          Print with Zebra
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryDetailsPrintModal;
